import React from 'react';

const Impressum = function () {
  return (
    <div className="impressum">
      <h1>Ersteller der Webseite</h1>
      <a href="mailto:roman@kram3r.ch">Roman Kramer</a>
      <h1>JS und CSS Helfer</h1>
      <p>Vielen Dank für die Unterstützung.</p>
      <p>S4ndr0</p>
      <h1>Icons und Bilder</h1>
      <p>Ein weiteres Dankeschön für die tollen Grafiken an:</p>
      <ul>
        <li>Icon made by <a href="https://www.flaticon.com/authors/maxim-basinski" >Maxim Basinski</a> from www.flaticon.com</li>
        <li>Icon made by <a href="https://smashicons.com/">smashicons</a> from www.flaticon.com</li>
        <li>Icon made by <a href="https://www.freepik.com/">freepik</a> from www.flaticon.com</li>
      </ul>
    </div>
  );
};

export default (Impressum);



// WEBPACK FOOTER //
// ./src/pages/Impressum/index.js